// @ts-nocheck
import {Column} from 'react-table'
import {CustomHeader} from './CustomHeader'
import {SelectionHeader} from './SelectionHeader'
import {User} from '../../core/_models'
import {CustonCell} from './CustonCell'
import {formatMask, formatMonetaryToBr} from '../../../../../../utils/formatMonetaryToBr'
import {formatDateTime} from '../../../../../../utils/dayJs/format'
import {PaymentHeader} from './PaymentHeader'
import {cpfMask} from '../../../../../../utils/cpfMask'

const ReportSalesColumns: ReadonlyArray<Column<User>> = [
  {
    Header: (props) => <CustomHeader tableProps={props} title='Contrato' className='min-w-125px' />,
    id: 'contract',
    Cell: ({...props}) => <CustonCell value={props.data[props.row.index].contract} />,
  },
  {
    Header: (props) => <CustomHeader tableProps={props} title='Status' className='min-w-125px' />,
    id: 'statusName',
    Cell: ({...props}) => <CustonCell value={props.data[props.row.index].statusName} />,
  },

  {
    Header: (props) => (
      <CustomHeader tableProps={props} title='Dt Contrato' className='min-w-125px' />
    ),
    id: 'createdAt',
    Cell: ({...props}) => (
      <CustonCell value={formatDateTime(props.data[props.row.index].createdAt)} />
    ),
  },
  {
    Header: (props) => (
      <CustomHeader tableProps={props} title='nome cliente' className='min-w-125px' />
    ),
    id: 'client_name',
    Cell: ({...props}) => (
      <CustonCell
        value={props.data[props.row.index].clientName}
        activeAlert={props.data[props.row.index].activeAlert}
        alertObservation={props.data[props.row.index].alertObservation}
      />
    ),
  },
  {
    Header: (props) => <CustomHeader tableProps={props} title='CPF' className='min-w-125px' />,
    id: 'clientDocument',
    Cell: ({...props}) => (
      <CustonCell value={`${cpfMask(props.data[props.row.index].clientDocument)}`} />
    ),
  },
  {
    Header: (props) => <CustomHeader tableProps={props} title='unidade' className='min-w-125px' />,
    id: 'franchiseName',
    Cell: ({...props}) => <CustonCell value={`${props.data[props.row.index].franchiseName}`} />,
  },
  {
    Header: (props) => (
      <PaymentHeader tableProps={props} title='Formas de pagamento' className='min-w-125px' />
    ),
    id: 'payments',
    Cell: ({...props}) => (
      <CustonCell
        value={
          <div className='card-body py-3 mt-3'>
            <div className='table-responsive'>
              <table className='table table-bordered table-hover table-row-bordered table-row-gray-100'>
                <tbody>
                {JSON.parse(props?.data[props.row.index]?.payments || '[]').map(
                    (item, index) => (
                        <tr key={`payments${index}`}>
                          <td>{item.payment_option}</td>
                          <td>{formatMask(item.amount)}</td>
                        </tr>
                    )
                )}
                </tbody>
              </table>
            </div>
          </div>
        }
      />
    ),
  },
  {
    Header: (props) => (
      <CustomHeader tableProps={props} title='Vr desconto' className='min-w-125px' />
    ),
    id: 'discount',
    Cell: ({...props}) => <CustonCell value={formatMask(props.data[props.row.index].discount)} />,
  },
  {
    Header: (props) => (
      <CustomHeader tableProps={props} title='Vr crédito voucher' className='min-w-125px' />
    ),
    id: 'voucherCredit',
    Cell: ({...props}) => (
      <CustonCell value={formatMask(props.data[props.row.index].voucherCredit)} />
    ),
  },
  {
    Header: (props) => (
      <CustomHeader tableProps={props} title='Vr total faturável' className='min-w-125px' />
    ),
    id: 'totalPrice',
    Cell: ({...props}) => <CustonCell value={formatMask(props.data[props.row.index].totalPrice)} />,
  },
]

export {ReportSalesColumns}
